// Slovenian

export default {

  component: {
    jobAdList: {
      title: 'Odprta delovna mesta',
      jobs: 'dela',
      noJobAds: 'Trenutno ni odprtih delovnih mest.',
    },

    jobAdCard: {
      openUntil: date => `Odprto do ${date}`,
    },

    jobAdGreetings: {
      thankYou: 'Hvala.',
      readyInfo: 'Vaša prijava je zdaj prejeta in naši zaposleni se vam bodo kmalu javili.',
      luck: 'Veliko sreče!',
    },

    jobAdSeeYou: {
      title: 'Hvala.',
      description: 'Vaša prijava je shranjena, poslali pa smo vam povezavo, da lahko s prijavo nadaljujete kasneje.',
    },

    unpublished: {
      title: 'Neobjavljeno',
      info: 'Prosto delovno mesto še ni bilo objavljeno.',
    },
  },

  page: {},

}
